import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid
} from "@mui/material";
import {
  LineChart,
  PieChart,
  Pie,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from "recharts";

export default function AgentAnalytics({ leads }) {
  const monthly = [
    { month: "Jan", leads: 30 },
    { month: "Feb", leads: 22 },
    { month: "Mar", leads: 44 },
    { month: "Apr", leads: 38 },
    { month: "May", leads: 50 },
  ];

  const statusPie = [
    { name: "Active", value: leads.filter(l => l.status === "Active").length },
    { name: "Closed", value: leads.filter(l => l.status === "Closed").length }
  ];

  const COLORS = ["#ff9800", "#4caf50"];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
        Agent Performance Analytics
      </Typography>

      <Grid container spacing={3} >
        {/* Monthly Leads */}
        <Grid item xs={12} md={2} sm={6}>
          <Paper sx={{ p: 2, borderRadius: 3, boxShadow: 2 ,width:"400px"}}>
            <Typography fontWeight={600}>Monthly Leads</Typography>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={monthly}>
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="leads" stroke="#ff9800" />
              </LineChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>

        {/* Status Ratio */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, borderRadius: 3, boxShadow: 2 ,width:"400px"}}>
            <Typography fontWeight={600}>Lead Status Ratio</Typography>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={statusPie}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  label
                >
                  {statusPie.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                </Pie>
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
